import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type XMarkProps = {
    className?: string;
};

const XMark: FunctionComponent<XMarkProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'x-mark'}
            viewBox="0 0 16 16"
        >
            <path d="M9.414 8l6.364-6.364L14.364.222 8 6.586 1.636.222.222 1.636 6.586 8 .222 14.364l1.414 1.414L8 9.414l6.364 6.364 1.414-1.414L9.414 8z" />
        </svg>
    );
};
export default XMark;
